<template>
  <div>
    <vx-card>

      <vs-row >
        <vs-col class="w-1/2 mb-6 pr-2" vs-align="center">
          <vs-button class="w-full" color="secondary" @click="handleUserInfoModified">저장</vs-button>
        </vs-col>
        <vs-col class="w-1/2 mb-6 pl-2" vs-align="center">
          <vs-button class="w-full" color="#EDEDED" text-color="black" type="filled" @click="handleUserInfoClear">취소</vs-button>
        </vs-col>
      </vs-row>
      <div>
        <vs-row>
          <vs-col class="mb-6 flex" vs-align="center">
            <h5 style="height:21px;"><i class="dot"></i>개인정보입력</h5>
          </vs-col>
          <vs-col >
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2">ID</h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" v-model="form.username" :readonly="true"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2">비밀번호</h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" v-model="form.password"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2">비밀번호확인</h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" v-model="form.password_confirmation"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2">회원권한</h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" v-model="form.authority" :readonly="true"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2">이름</h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" v-model="form.name"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2">이메일</h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" v-model="form.email"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2">생년월일</h5>
              <date-selector class="vx-col sm:w-8/12 w-full " v-model="form.birthdate"></date-selector>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col w-full mb-2">핸드폰 번호</h5>
              <vs-input class="vx-col w-3/12" placeholder="" v-model="phone_1"/>
              <span class="mx-2">-</span>
              <vs-input class="vx-col w-3/12 " placeholder="" v-model="phone_2"/>
              <span class="mx-2">-</span>
              <vs-input class="vx-col w-3/12 " placeholder="" v-model="phone_3"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="start">
              <h5 class="flex vx-col sm:w-3/12" style="height:37px; align-items: center;">프로필 이미지</h5>
              <vs-upload class="sm:w-9/12 m-0 p-0" ref="vs_upload_1" :action="fileUpLoad.action" :headers="fileUpLoad.headers"
                         @change="handleChangeFile" @on-success="handleSuccessFileUpload" @on-delete="handleDeleteFile"
                         automatic file-name="file_data" :show-upload-button="false" limit="1"></vs-upload>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col w-full mb-2">회사명</h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" :value="getCompanyInfo.com_name" :readonly="true"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col w-full mb-2">근무지주소</h5>
              <vs-col class="w-full">
                <div class="grid" style="grid-template-columns: 1fr auto">
                  <div class="w-full pr-3">
                    <vs-input class="vx-col w-full " readonly placeholder="우편번호" v-model="form.home_zip"/>
                  </div>
                  <vs-button color="primary" type="border" @click="postcode.active = true">우편번호</vs-button>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center" style="">
              <h5 class="vx-col sm:w-3/12 mb-2"></h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" v-model="form.home_address_1"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2"></h5>
              <vs-input class="vx-col sm:w-8/12 w-full " placeholder="" v-model="form.home_address_2"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col w-3/12 mb-2">부서</h5>
              <vs-input class="vx-col w-9/12 " placeholder="" v-model="form.department"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col w-3/12 mb-2">직급</h5>
              <vs-input class="vx-col w-9/12 " placeholder="" v-model="form.rank"/>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col w-3/12 mb-2">직책</h5>
              <vs-select id="tableSelect" autocomplete label="" v-model="form.position" class="w-9/12" >
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in workPosition"/>
              </vs-select>
            </vs-row>
            <vs-row class="flex mb-4" vs-align="center">
              <h5 class="vx-col w-3/12">이메일</h5>
              <vs-input class="vx-col w-9/12 " placeholder="" v-model="form.email"/>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>

    </vx-card>

    <!-- 다음우편번호 -->
    <vs-popup id="postcodePopup" :title="postcode.title" :active.sync="postcode.active">
      <vue-daum-postcode @complete="handlePostcodeComplete" />
    </vs-popup>
  </div>
</template>

<script>
import { VueDaumPostcode } from 'vue-daum-postcode'
import DateSelector from '@/views/components/DateSelector'
import FileUploader from '@/views/components/FileUploader'
import VueCookie from 'vue-cookie'
import config from '/public/config'
export default {
  name: 'MobileMyPageInfoUpdate',
  components: {
    FileUploader,
    DateSelector,
    VueDaumPostcode},

  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {

      if (this.$refs.vs_upload_1.$children && this.$refs.vs_upload_1.$children.length > 0) {
        this.$refs.vs_upload_1.viewActive = false
        next(false)
      } else if (this.postcode.active) {
        this.postcode.active = false

        next(false)
      } else {

        next(true)
      }

    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },

  computed: {
    getCompanyInfo () {
      return this.$store.state.company.companyInfo
    }
  },

  data () {
    return {
      phone_1:'',
      phone_2:'',
      phone_3:'',
      form:{
        username: '',
        email: '',
        name: '',
        surname: '',
        password: '',
        password_confirmation: '',
        nickname: '',
        birthdate: '',
        mobile: '',
        phone: '',
        home_zip: '',
        home_address_1: '',
        home_address_2: '',
        com_name:'',
        company_zip: '',
        company_address_1: '',
        company_address_2: '',
        mail_destination: '',
        is_activated: '',
        avatar: '',
      },
      oldForm:{},
      postcode:{
        active:false,
        title:'우편번호 검색'
      },
      fileUpLoad: {
        headers: '',
        action: `${config.BASE_API_URL}/api/v1/file`,
        files: [], // 등록하고자 하는 파일 목록
        oldFileIds: [], // 기존에 등록한 파일Id 목록
      },
      workPosition:[]
    }
  },
  async created () {
    // file upload 시 사용되는 xmlrequest header
    this.fileUpLoad.headers = {
      Authorization: `Bearer ${VueCookie.get('token')}`,
    }
    await this.loadInfoWorkPosition()
    await this.loadMember()
  },
  beforeMount () {

  },
  methods:{
    // 회원정보 불러오기
    async loadMember () {
      const userId = this.$store.state.auth.userInfo.id
      await this.$store.dispatch('member/LOAD_MEMBER', {userId})

      // 수정된 부분을 체크하기위해 깊은복사를 한다.
      const member = Object.assign({}, this.$store.state.member.memberInfo)
      this.form = member
      let phone_1 = ''
      let phone_2 = ''
      let phone_3 = ''
      if (this.form.phone.length === 11) {
        phone_1 = this.form.phone.substr(0, 3)
        phone_2 = this.form.phone.substr(3, 4)
        phone_3 = this.form.phone.substr(7, 4)
      } else {
        phone_1 = this.form.phone.substr(0, 2)
        phone_2 = this.form.phone.substr(2, 4)
        phone_3 = this.form.phone.substr(6, 4)
      }
      this.phone_1 = phone_1
      this.phone_2 = phone_2
      this.phone_3 = phone_3
      await this.$store.dispatch('company/LOAD_COMPANY', {companyId:this.form.company_id})

      // 이슈(MARK_001)을 해결하기 위해 value에 prefix를 추가한다.
      this.subscribe_email = (member.subscribe_email) ? 'email_1' : 'email_0'
      this.subscribe_sms = (member.subscribe_sms) ? 'sms_1' : 'sms_0'

      // 프로필 이미지 존재시, vs-upload에 이미지를 넣어준다.
      if (member.avatar) {
        this.setVsUploadImage(this, member.avatar.path, member.avatar.id)
      }

      this.oldForm = JSON.parse(JSON.stringify(this.form))
    },

    // vs-upload에 초기 이미지 넣기
    async setVsUploadImage (_t, src, uploadedFileId) {
      let orientation = 'h'
      const image = new Image()
      image.src = src
      image.onload = function () {
        if (this.width > this.height) {
          orientation = 'w'
        }

        const obj = {
          uploadedFileId,
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        }

        _t.$refs.vs_upload_1.srcs = [JSON.parse(JSON.stringify(obj))]
        _t.$refs.vs_upload_1.filesx = [JSON.parse(JSON.stringify(obj))]
      }

    },
    async loadInfoWorkPosition () {
      await this.$store.dispatch('project/HSE_LOAD_INFO_WORKPOSITION')
      const list = this.$store.state.project.hseInfoWorkPositionList

      this.workPosition = []
      for (const item of list) {
        this.workPosition.push({text:item.name, value:item.id})
      }
    },

    handleUserInfoModified () {
      const file = this.fileUpLoad.files[this.fileUpLoad.files.length - 1]
      if (file) this.form.avatar = (file.uploadedFileId) ? file.uploadedFileId : ''
      else delete this.form.avatar

      this.form.phone = `${this.phone_1}${this.phone_2}${this.phone_3}`
      this.form.userId = this.form.id
      this.form.is_activated = (this.form.is_activated) ? 1 : 0
      this.$store.dispatch('member/MODIFY_MEMBER', this.form)

      alert('저장되었습니다.')
    },

    async handleUserInfoClear () {
      document.location.reload()
      //this.form = JSON.parse(JSON.stringify(this.oldForm))
      //this.fileUpLoad.files.remove()

      //await this.setVsUploadImage(this, this.form.avatar.path, this.form.avatar.id)
    },

    handlePostcodeComplete (data) {

      // 도로명(R), 지번(J)
      const userSelectedType = data.userSelectedType

      // 우편번호
      const zonecode = data.zonecode

      // 주소
      let address1 = data.roadAddress
      if (userSelectedType === 'J') {
        address1 = data.jibunAddress
      }


      // 자택주소
      if (this.postcode.active) {
        this.form.home_zip = zonecode
        this.form.home_address_1 = address1
      }

    },

    handleChangeFile (path, files) {
      this.fileUpLoad.files = files
    },

    handleSuccessFileUpload (event) {
      // response
      let response = event.currentTarget.response
      response = JSON.parse(response)
      const uploadedFileID = response.id

      const file = this.fileUpLoad.files[this.fileUpLoad.files.length - 1]
      file.uploadedFileId = uploadedFileID
    },

    handleDeleteFile (file) {
      if (file.src) {
        this.fileUpLoad.oldFileIds.remove(file.uploadedFileId)
      } else {
        this.fileUpLoad.files.remove(file)
      }
    },

  }
}
</script>

<style scoped>
</style>

<style>
#postcodePopup .vue-daum-postcode-container {height:450px !important;}

[dir] .con-input-upload {
  margin: 0;
}
[dir] .con-img-upload {
  padding:0;
}
</style>
